import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { RsIcon } from '../icons'
import { chatFileDownloadUrl } from '../../utils/chatFiles'

async function parseBlobError(err) {
  const data = err?.response?.data
  if (data instanceof Blob) {
    try {
      const json = JSON.parse(await data.text())
      return json.message || 'Failed to load image'
    } catch {
      return 'Failed to load image'
    }
  }
  return err?.response?.data?.message || err?.message || 'Failed to load image'
}

export default function ChatImageAttachment({ msg, variant = 'message', onPreview, onDownload }) {
  const [src, setSrc] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    const url = chatFileDownloadUrl(msg)
    if (!url) {
      setLoading(false)
      setError('Image unavailable')
      return undefined
    }

    let cancelled = false
    let blobUrl = null

    axios.get(url, { responseType: 'blob' })
      .then((res) => {
        if (cancelled) return
        const contentType = String(res.headers['content-type'] || '')
        if (contentType.includes('application/json')) {
          throw new Error('Image unavailable')
        }
        blobUrl = window.URL.createObjectURL(res.data)
        setSrc(blobUrl)
        setError('')
      })
      .catch(async (err) => {
        if (!cancelled) setError(await parseBlobError(err))
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })

    return () => {
      cancelled = true
      if (blobUrl) window.URL.revokeObjectURL(blobUrl)
    }
  }, [msg?.id, msg?.fileId, msg?.legacyFile])

  if (loading) {
    return <div className={`rs-chat-image-slot ${variant}`}>Loading image…</div>
  }

  if (error || !src) {
    return (
      <div className={`rs-chat-image-slot error ${variant}`}>
        <RsIcon name="image" size="sm" />
        <span>{error || 'Image unavailable'}</span>
      </div>
    )
  }

  return (
    <div className={`rs-chat-image-attachment ${variant}`}>
      <button
        type="button"
        className="rs-chat-image-thumb-btn"
        onClick={(e) => {
          e.stopPropagation()
          onPreview?.({ msg, src })
        }}
        title="Click to enlarge"
      >
        <img src={src} alt={msg.fileName || msg.text || 'Image'} className="rs-chat-image-thumb" />
      </button>
      <div className="rs-chat-image-actions">
        <button
          type="button"
          className="rs-chat-msg-file-btn"
          onClick={(e) => onDownload?.(msg, e)}
        >
          Download
        </button>
      </div>
    </div>
  )
}
